module.exports = __webpack_public_path__ + "img/magento-code-review.84375937.webp";